/**
 * Moved to `shared/src/review/serp-snippet-segments.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildSerpFoldedTermSegments,
  buildSerpSnippetSegments
} from '@taptimize/shared/dist/review/serp-snippet-segments';
export type {
  SerpMisalignedLink,
  SerpSnippetSegment
} from '@taptimize/shared/dist/review/serp-snippet-segments';
